import { IS_DEV, IS_UAT } from "../config";

const staticCodes = [
  { "42": "15026" },
  { "46": "15026" },
  { "64": "15026" },
  { "45": "15012" },
  { "66": "15012" },
  { "110": "15012" },
  { "40": "15014" },
  { "39": "15017" },
  { "43": "15057" },
  { "44": "15063" },
  { "93": "15065" },
  { "95": "15419" },
  { "116": "79785" },
  { "115": "79785" },
  { "112": "77002" },
  { "113": "75001" },
  { "114": "76883" },
  { "121": "79415" },
  { "79": "44032" },
  { "90": "44032" },
  { "91": "44032" },
  { "82": "43812" },
  { "80": "43011" },
  { "89": "43414" },
  { "83": "45001" },
  { "84": "45001" },
  { "81": "43812" },
  { "92": "43206" },
  { "96": "44870" },
  { "97": "20023" },
  { "98": "20023" },
  { "119": "19804" },
  { "67": "01040" },
  { "68": "01040" },
  { "99": "01040" },
  { "111": "01040" },
  { "70": "02467" },
  { "69": "02467" },
  { "120": "03060" },
  { "74": "07869" },
  { "104": "07462" },
  { "62": "07066" },
  { "63": "07869" },
  { "75": "07869" },
  { "101": "07066" },
  { "102": "08012" },
  { "103": "08012" },
  { "58": "60002" },
  { "122": "19092" },
  { "123": "48021" },
];

export { staticCodes };
